import { render, staticRenderFns } from "./PolandOrders.vue?vue&type=template&id=23e9894a&"
import script from "./PolandOrders.vue?vue&type=script&lang=js&"
export * from "./PolandOrders.vue?vue&type=script&lang=js&"
import style0 from "./PolandOrders.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports